/**
 * Deferred-auth `returnTo` handling for the shell/partner auth flows.
 *
 * A `returnTo` lets a guest resume where they were after sign-up/sign-in, so it is
 * attacker-influenced (it rides in the URL) and feeds a client-side redirect —
 * i.e. an open-redirect sink. Only a genuine same-origin RELATIVE path is safe:
 * a single leading "/" that is NOT followed by another "/" or a "\". Browsers
 * normalise "\" to "/", so "/\evil.com" (and "//evil.com") would otherwise resolve
 * to the protocol-relative "//evil.com" and navigate off-site.
 */

/** Validate a raw `returnTo` value; returns it unchanged if same-origin-relative, else null. */
export function sanitizeReturnTo(raw: string | null | undefined): string | null {
  return raw && /^\/(?![/\\])/.test(raw) ? raw : null;
}

/** Read `returnTo` from the current URL, sanitized. Returns null on the server (no window). */
export default function safeReturnTo(): string | null {
  if (typeof window === 'undefined') return null;
  return sanitizeReturnTo(new URLSearchParams(window.location.search).get('returnTo'));
}
